export const LinkTypes = ["showcase","jobDetail","recruiterProfile","webView"]

export const LinkTypesMapper = {
    1: "Showcase",
    2: "Job Detail",
    3: "Recruiter Profile",
    4: "External Link",
    5: "Round Zero"
}